import styled from 'styled-components';
import { Modal } from '@whitelabel/component-library';
import { fontWeight } from '@whitelabel/helpers/style/type';
import { themeColor, color } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { ceruleanGradient } from '@whitelabel/global-theme/colors';

export const StyledModal = styled(Modal)`
  > .modal-content {
    background: ${ceruleanGradient} 100% 0 / 800px 79% no-repeat,
      linear-gradient(to bottom, ${color('white')}, ${color('white')});
    ${mediaBreakpointUp('md')`
      padding: 2rem;
      background: ${ceruleanGradient}
        100% 0 / 800px 70% no-repeat,
      linear-gradient(to bottom, ${color('white')}, ${color('white')});
    `}

    > .modal-header .btn-close {
      font-weight: ${fontWeight('base')};
      font-size: 2rem;
      color: ${themeColor('primaryBg')};
      opacity: 1;
      ${mediaBreakpointUp('md')`
        padding: 0.5rem;
      `}
    }

    > .modal-body {
      margin-bottom: 0;

      div > .h1 {
        font-size: 1.5rem;
        font-weight: ${fontWeight('medium')};
        text-transform: none;
        margin-bottom: 0;
        color: ${themeColor('primaryBg')};
        ${mediaBreakpointUp('md')`
          font-size: 1.75rem;
          margin-bottom: 0.5rem;
        `}
      }

      div > .subtext {
        font-weight: ${fontWeight('medium')};
        font-size: 1.25rem;
        color: ${themeColor('primaryBg')};
      }

      ${mediaBreakpointUp('md')`
        display: flex;
        align-items: center;
        height: 14.5rem;
        margin-bottom: 2rem;
      `}
    }

    > .modal-footer {
      border-top: none;
      padding-top: 0.5rem;
    }
  }
`;

export const StyledLottie = styled.div`
  cursor: auto;
  height: 16rem;
  margin-inline-end: 3rem;
  ${mediaBreakpointUp('md')`
    height: 20rem;
    margin: 5rem 0 0 0;
  `}
`;
